module.exports = __webpack_public_path__ + "static/favicon-32-020dd768a861e31def2e8fa3b88af3cf.png";